// extracted by mini-css-extract-plugin
export default {"expire_time":"dataTime_expire_time__E5oR-"};